import React from "react";
import moment from "moment";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postSwissportForm } from "../../redux/actions/swissportActions";

const EmployeeHealthQuestionnaire = ({ appData, postSwissportFormFunc }) => {
  const { firstName = "", lastName = "" } = {
    ...appData,
  };

  const style = {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-evenly",
  };

  const initialData = {
    firstName,
    lastName,
  };

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);
  const validateTrue = (value) => !!value;

  const listOfHealthQs = [];

  for (let i = 0; i <= 26; i += 1) {
    listOfHealthQs.push({ fieldKey: `health${i + 1}` });
  }

  const initialState = {
    blurbBeginning: {
      htmlObj: (
        <div>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Employers have a duty to look after the health, safety and
            well-being of all their employees. We require our employees to
            complete the following health questionnaire.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Please note that this information will only be used to assess
            whether there are any health issues relevant to your job role and to
            guide the company on any special requirements you may have during
            your employment with us.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            More specifically, it provides the Company with an opportunity to:
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            • Identify any risks of the job role to you
            <br />
            • Identify any support you may need to do your job effectively
            <br />• Identify any potential reasonable adjustments we may need to
            consider making if you have a disability
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            There may be occasions where further assessment by an Occupational
            Health Advisor is required or where the Company need to obtain
            further information from your GP or Specialist, but we will only ask
            for this information when absolutely necessary and when we have
            obtained your written consent.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Please be reassured that we would only ask for this information to
            ensure we support you in the best way we can.
          </p>
        </div>
      ),
    },
    blurbSection1: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Employee details"} />
        </div>
      ),
    },
    lastNameEHQ: {
      title: "Last Name:",
      value: getVal("lastName"),
      mandatory: true,
    },
    firstNameEHQ: {
      title: "Fist Name:",
      value: getVal("firstName"),
      mandatory: true,
    },
    middleNameEHQ: {
      title: "Middle Name:",
      value: getVal("middleName"),
    },
    blurbSection2: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Work related health History"} />
        </div>
      ),
    },
    health1: {
      title:
        "Have you ever been absent from work or full-time study due to ill health during the last 2 years?",
      value: getVal("health1"),
      type: "checkbox",
      mandatory: true,
    },
    health2: {
      title: "Have you ever had to leave a previous job for medical reasons?",
      value: getVal("health2"),
      type: "checkbox",
      mandatory: true,
    },
    health3: {
      title: "Have you ever been denied a driving licence on medical grounds?",
      value: getVal("health3"),
      type: "checkbox",
      mandatory: true,
    },
    health4: {
      title:
        "Do you have any condition or medication that may adversely affect your ability to drive? (This question is particularly important and must be completed for jobs that require you to drive vehicles and operate equipment)",
      value: getVal("health4"),
      type: "checkbox",
      mandatory: true,
    },
    health5: {
      title:
        "Have you ever suffered from any work-related health conditions? (Please include persistent complaints such as repetitive strain injury, skin complaints etc.)",
      value: getVal("health5"),
      type: "checkbox",
      mandatory: true,
    },
    health6: {
      title:
        "Do you have any medical conditions which may affect your ability to do night working? (Night work can lead to problems for employees with particular medical conditions such as diabetes, heart or circulatory disorders, stomach or intestinal disorders, conditions that cause sleeping difficulties, chronic chest disorders, and medical conditions that require medication to a strict timetable.)",
      value: getVal("health6"),
      type: "checkbox",
      mandatory: true,
    },
    health7: {
      title:
        "Do you have any condition of the lungs? (For example: Asthma, Bronchitis, Pleurisy, Tuberculosis and other chest complaints?)",
      value: getVal("health7"),
      type: "checkbox",
      mandatory: true,
    },
    health8: {
      title:
        "Do you have any conditions of the heart? (For example: High blood pressure, Heart attacks, Angina?)",
      value: getVal("health8"),
      type: "checkbox",
      mandatory: true,
    },
    health9: {
      title:
        "Do you have a nervous system disorder? (For example: Blackouts, Epilepsy, Muscular weakness, Paralysis?)",
      value: getVal("health9"),
      type: "checkbox",
      mandatory: true,
    },
    health10: {
      title: "Do you suffer from migraine or persistent headaches?",
      value: getVal("health10"),
      type: "checkbox",
      mandatory: true,
    },
    health11: {
      title:
        "Do you have conditions of the bones, joints, limbs? (For example; Arthritis, Rheumatism, Back problems, Sciatica, Upper limb disorder, Hips or Knees? Any other conditions?)",
      value: getVal("health11"),
      type: "checkbox",
      mandatory: true,
    },
    health12: {
      title:
        "Do you have any problems with joints or muscles? (For example; wrists, hands, ankles and feet)",
      value: getVal("health12"),
      type: "checkbox",
      mandatory: true,
    },
    health13: {
      title:
        "Do you have any problems with: Lifting or bending? Prolonged or repeated crouching or kneeling? Raising arms above shoulder height?",
      value: getVal("health13"),
      type: "checkbox",
      mandatory: true,
    },
    health14: {
      title: "Do you have any problems with backache or neck ache?",
      value: getVal("health14"),
      type: "checkbox",
      mandatory: true,
    },
    health15: {
      title:
        "Do you have any problems with your shoulders or elbows? (Including Tennis Elbow)",
      value: getVal("health15"),
      type: "checkbox",
      mandatory: true,
    },
    health16: {
      title:
        "Do you have any problems with bone fracture, joint dislocation or any surgery to muscles?",
      value: getVal("health16"),
      type: "checkbox",
      mandatory: true,
    },
    health17: {
      title:
        "Is there any reason that you cannot carry out any strenuous manual work (including climbing ladders, working from scaffolding, bending, lifting and carrying)?",
      value: getVal("health17"),
      type: "checkbox",
      mandatory: true,
    },
    health18: {
      title:
        "Do you have any allergies? (Including allergies to drugs, animals, nuts, wheat, dairy foods and pollens)",
      value: getVal("health18"),
      type: "checkbox",
      mandatory: true,
    },
    health19: {
      title:
        "Do you have any gland trouble, have diabetes or a thyroid-related condition?",
      value: getVal("health19"),
      type: "checkbox",
      mandatory: true,
    },
    health20: {
      title:
        "Do you have any alcohol or drug problems? (For example; Problems related to alcohol or drug usage or dependency)",
      value: getVal("health20"),
      type: "checkbox",
      mandatory: true,
    },
    health21: {
      title:
        "Do you have an eye condition? (For example; Restricted vision, Glaucoma, Iritis, Colour blindness or any other eye condition?)",
      value: getVal("health21"),
      type: "checkbox",
      mandatory: true,
    },
    health22: {
      title:
        "Do you have an ear condition? (For example; Restricted hearing, Tinnitus, Ear infection)",
      value: getVal("health22"),
      type: "checkbox",
      mandatory: true,
    },
    health23: {
      title: "Are you receiving medical treatment at the present time?",
      value: getVal("health23"),
      type: "checkbox",
      mandatory: true,
    },
    health24: {
      title: "Are you currently taking any regular medication?",
      value: getVal("health24"),
      type: "checkbox",
      mandatory: true,
    },
    health25: {
      title:
        "Are you aware of having any disability that is covered by the Equality Act 2010?",
      value: getVal("health25"),
      type: "checkbox",
      mandatory: true,
    },
    health26: {
      title:
        "Have you any disabilities affecting sight, hearing, standing, sitting, walking, lifting, driving, stair climbing, use of the hands or anything indicated in the job vacancy/jobdescription?",
      value: getVal("health26"),
      type: "checkbox",
      mandatory: true,
    },
    health27: {
      title:
        "Have you any other health issues that have not been mentioned above or about which you would like to provide further information?",
      value: getVal("health27"),
      type: "checkbox",
      mandatory: true,
    },
    blurbSection3: {
      htmlObj: (
        <div>
          <HorizontalLine text={"Further details"} />
          If you answered Yes to any question above, please use this space to
          provide further detail and relevant dates
        </div>
      ),
      dependOnAny: listOfHealthQs,
    },
    questionNumber1: {
      title: "Question number:",
      value: getVal("questionNumber1"),
      style,
      inputWidth: "70px",
      mandatory: true,
      dependOnAny: listOfHealthQs,
    },
    questionAnswer1: {
      title: "Description:",
      value: getVal("questionAnswer1"),
      mandatory: true,
      dependOnAny: listOfHealthQs,
    },
    questionNumber2: {
      title: "Question number:",
      value: getVal("questionNumber2"),
      style,
      inputWidth: "70px",
      mandatory: true,
      dependOnExact: [listOfHealthQs, 2],
    },
    questionAnswer2: {
      title: "Description:",
      value: getVal("questionAnswer2"),
      mandatory: true,
      dependOnExact: [listOfHealthQs, 2],
    },
    questionNumber3: {
      title: "Question number:",
      value: getVal("questionNumber3"),
      style,
      inputWidth: "70px",
      mandatory: true,
      dependOnExact: [listOfHealthQs, 3],
    },
    questionAnswer3: {
      title: "Description:",
      value: getVal("questionAnswer3"),
      mandatory: true,
      dependOnExact: [listOfHealthQs, 3],
    },
    blurbSection4: {
      htmlObj: (
        <div>
          <HorizontalLine text="Declaration" />
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            The information contained in this questionnaire shall be protected
            in accordance with the principles of the Data Protection Act 1998
            (UK), Data Protection Act 1998 (Ireland) and Data Protection
            (Jersey) Law 2005, and will not be divulged to any third party
            unless the information is required to prevent fraud or a criminal
            act.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Please ensure that you have provided all the information required
            and then complete the declaration below:
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            • I confirm that to the best of my knowledge and belief the
            information provided in this health questionnaire is complete and
            accurate.
            <br />
            • I understand that if it is later found that I have not disclosed
            medical information, or that the information I have provided is
            misleading, false or inaccurate, this may disqualify me from
            employment or could result in disciplinary action being taken
            against me up to and including summary dismissal.
            <br />• I understand and accept that I may be required to attend an
            Occupational Health assessment.
            <br />• I understand and accept that further medical information may
            be requested by the Company from my GP/Specialist if necessary,
            subject to my consent (NB Access to Medical Reports Act 1998 applies
            to UK employees).
          </p>
        </div>
      ),
    },
    declarationEHQ: {
      title: "I understand and agree to the declaration above.*",
      value: getVal("declarationEHQ"),
      type: "singlecheckbox",
      validate: validateTrue,
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    const dateFormatted = moment().format("DDMMYYYY");
    const dateIntoObject = dateFormatted
      .split("")
      .splice(0, 8)
      .reduce(
        (acc, v, i) => ({ ...acc, [`date${i + 1}`]: v }), // Compute the key and assign value
        {}
      );

    postSwissportFormFunc("employerHealthQuestionnaire", {
      ...dateIntoObject,
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/swissport-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Employee Health Questionnaire"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/swissport-onboarding")}
      onboardingBranch={"swissport"}
    />
  );
};
EmployeeHealthQuestionnaire.propTypes = {
  appData: any,
  postSwissportFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postSwissportFormFunc: postSwissportForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(EmployeeHealthQuestionnaire);
